import DataListPage from "./DataListPage";
import { firestore } from "firebase";
import { SamplingResult } from "../components/SamplingResultsTable";
import * as fs from "../firestore";

const samplingResultsRef = firestore().collection(fs.Collection.SamplingResults);
const analysisResultsRef = firestore().collection(fs.Collection.AnalysisResults);

export default class CustomerDataListPage extends DataListPage {
    getExcelGenerationFunction(): string {
        return "createCustomerExcel";
    }
    getPageTitle(): string {
        return "計測データ一覧"
    }
    getShowDeleteFlag(): boolean {
        return false;
    }
    makeFetchSamplingResultsQuery(limit: number, startAfter: SamplingResult|null, reverseOrder: boolean) {
        let query = samplingResultsRef
            .limit(limit)
            .orderBy("fieldName", reverseOrder ? "desc" : "asc")
            .orderBy("createDateTime", reverseOrder ? "asc" : "desc")
            .where("deleteFlag", "==", false)
            .where("userRef", "==", firestore().collection(fs.Collection.Users).doc(this.props.user.uid))
        if (startAfter != null) {
            query = query.startAfter(startAfter.fieldName,startAfter.createDateTime);
        }
        return query;
    }
    makeFetchAnalysisResultsQuery(samplingResultId: string) {
        return analysisResultsRef
            .orderBy("analysisId", "asc")
            .orderBy("createDateTime", "desc")
            .where("samplingResultRef", "==", samplingResultsRef.doc(samplingResultId))
            .where("deleteFlag", "==", false)
            .where("userRef", "==", firestore().collection(fs.Collection.Users).doc(this.props.user.uid));
    }
}
